import { Organization } from '../global';

export const ORGANIZATION_SEARCH = 'ORGANIZATION_SEARCH';
export const ORGANIZATION_SEARCH_RESULT = 'ORGANIZATION_SEARCH_RESULT';

export interface OrganizationData {
  organizations?: Organization[];
}
